import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';
import { SERVICE_TYPES } from 'constants/CheckoutConstants';

export const UPDATE_CHECKOUT_QUANTITY_REQUEST = 'UPDATE_CHECKOUT_QUANTITY_REQUEST';
export const UPDATE_CHECKOUT_QUANTITY_SUCCESS = 'UPDATE_CHECKOUT_QUANTITY_SUCCESS';
export const UPDATE_CHECKOUT_QUANTITY_ERROR = 'UPDATE_CHECKOUT_QUANTITY_ERROR';

export const UPDATE_DELIVERY_PROMISE_REQUEST = 'UPDATE_DELIVERY_PROMISE_REQUEST';
export const UPDATE_DELIVERY_PROMISE_SUCCESS = 'UPDATE_DELIVERY_PROMISE_SUCCESS';
export const UPDATE_DELIVERY_PROMISE_ERROR = 'UPDATE_DELIVERY_PROMISE_ERROR';

export const REMOVE_CHECKOUT_ITEM_REQUEST = 'REMOVE_CHECKOUT_ITEM_REQUEST';
export const REMOVE_CHECKOUT_ITEM_SUCCESS = 'REMOVE_CHECKOUT_ITEM_SUCCESS';
export const REMOVE_CHECKOUT_ITEM_ERROR = 'REMOVE_CHECKOUT_ITEM_ERROR';

export const UPDATE_CHECKOUT_EMAIL_REQUEST = 'UPDATE_CHECKOUT_EMAIL_REQUEST';
export const UPDATE_CHECKOUT_EMAIL_SUCCESS = 'UPDATE_CHECKOUT_EMAIL_SUCCESS';
export const UPDATE_CHECKOUT_EMAIL_ERROR = 'UPDATE_CHECKOUT_EMAIL_ERROR';

export const CHANGE_DELIVERY_SLOT_REQUEST = 'CHANGE_DELIVERY_SLOT_REQUEST';
export const CHANGE_DELIVERY_SLOT_SUCCESS = 'CHANGE_DELIVERY_SLOT_SUCCESS';
export const CHANGE_DELIVERY_SLOT_ERROR = 'CHANGE_DELIVERY_SLOT_ERROR';

export const APPLY_COINS_REQUEST = 'APPLY_COINS_REQUEST';
export const APPLY_COINS_SUCCESS = 'APPLY_COINS_SUCCESS';
export const APPLY_COINS_ERROR = 'APPLY_COINS_ERROR';

export const USE_GST_REQUEST = 'USE_GST_REQUEST';
export const USE_GST_SUCCESS = 'USE_GST_SUCCESS';
export const USE_GST_ERROR = 'USE_GST_ERROR';

function changeDeliverySlotRequestAction() {
	return { type: CHANGE_DELIVERY_SLOT_REQUEST };
}

function changeDeliverySlotSuccessAction(data) {
	return { type: CHANGE_DELIVERY_SLOT_SUCCESS, data };
}

function changeDeliverySlotErrorAction(error) {
	return { type: CHANGE_DELIVERY_SLOT_ERROR, error };
}

export function changeDeliverySlotAction(
	checkoutUpdateData,
	pincode,
	serviceType = SERVICE_TYPES.CHANGE_DELIVERY_SLOT
) {
	return dispatch => {
		dispatch(changeDeliverySlotRequestAction());
		return ApiCaller.put(
			{
				...baseAjaxConfig,
				pathname: '/api/5/checkout',
				acceptErrors: true
			},
			{
				checkoutUpdateData,
				serviceType,
				pincode
			}
		).then(
			json => {
				return dispatch(changeDeliverySlotSuccessAction(json['RESPONSE']));
			},
			err => {
				return dispatch(changeDeliverySlotErrorAction(err));
			}
		);
	};
}

export function updateCheckoutQuantityAction(checkoutUpdateData, pincode, serviceType = SERVICE_TYPES.UPDATE_QUANTITY) {
	function updateCheckoutQuantityRequestAction() {
		return { type: UPDATE_CHECKOUT_QUANTITY_REQUEST };
	}

	function updateCheckoutQuantitySuccessAction(data) {
		return { type: UPDATE_CHECKOUT_QUANTITY_SUCCESS, data };
	}

	function updateCheckoutQuantityErrorAction(error) {
		return { type: UPDATE_CHECKOUT_QUANTITY_ERROR, error };
	}

	return dispatch => {
		dispatch(updateCheckoutQuantityRequestAction());
		return ApiCaller.put(
			{
				...baseAjaxConfig,
				pathname: '/api/5/checkout',
				acceptErrors: true
			},
			{
				serviceType,
				pincode,
				checkoutUpdateData: [checkoutUpdateData]
			}
		).then(
			json => {
				return dispatch(updateCheckoutQuantitySuccessAction(json['RESPONSE']));
			},
			err => {
				return dispatch(updateCheckoutQuantityErrorAction(err));
			}
		);
	};
}

export function updateDeliveryPromiseAction(cartItemRefId, serviceValue, pincode) {
	function updateDeliveryPromiseRequestAction() {
		return { type: UPDATE_DELIVERY_PROMISE_REQUEST };
	}

	function updateDeliveryPromiseSuccessAction(data) {
		return { type: UPDATE_DELIVERY_PROMISE_SUCCESS, data };
	}

	function updateDeliveryPromiseErrorAction(error) {
		return { type: UPDATE_DELIVERY_PROMISE_ERROR, error };
	}

	return dispatch => {
		dispatch(updateDeliveryPromiseRequestAction());
		return ApiCaller.put(
			{
				...baseAjaxConfig,
				pathname: '/api/5/checkout',
				acceptErrors: true
			},
			{
				serviceType: SERVICE_TYPES.TIER,
				pincode,
				checkoutUpdateData: [
					{
						cartItemRefId,
						serviceValue
					}
				]
			}
		).then(
			json => {
				return dispatch(updateDeliveryPromiseSuccessAction(json['RESPONSE']));
			},
			err => {
				return dispatch(updateDeliveryPromiseErrorAction(err));
			}
		);
	};
}

export function removeCheckoutItemAction(listingIds = []) {
	function removeCheckoutItemRequestAction() {
		return { type: REMOVE_CHECKOUT_ITEM_REQUEST };
	}

	function removeCheckoutItemSuccessAction(data) {
		return { type: REMOVE_CHECKOUT_ITEM_SUCCESS, data };
	}

	function removeCheckoutItemErrorAction(error) {
		return { type: REMOVE_CHECKOUT_ITEM_ERROR, error };
	}

	return dispatch => {
		dispatch(removeCheckoutItemRequestAction());
		return ApiCaller.delete({
			...baseAjaxConfig,
			pathname: '/api/5/checkout',
			acceptErrors: true,
			query: {
				listingIds: listingIds.join(',')
			}
		}).then(
			json => {
				return dispatch(removeCheckoutItemSuccessAction(json['RESPONSE']));
			},
			err => {
				return dispatch(removeCheckoutItemErrorAction(err));
			}
		);
	};
}

export function updateCheckoutEmailRequestAction() {
	return { type: UPDATE_CHECKOUT_EMAIL_REQUEST };
}
export function updateCheckoutEmailSuccessAction(data) {
	return { type: UPDATE_CHECKOUT_EMAIL_SUCCESS, data };
}
export function updateCheckoutEmailErrorAction(error) {
	return { type: UPDATE_CHECKOUT_EMAIL_ERROR, error };
}
export function updateCheckoutEmailAction(emailId) {
	return dispatch => {
		dispatch(updateCheckoutEmailRequestAction());
		return ApiCaller.put(
			{
				...baseAjaxConfig,
				pathname: '/api/5/checkout/email',
				acceptErrors: true
			},
			{ emailId }
		).then(
			json => dispatch(updateCheckoutEmailSuccessAction(json['RESPONSE'])),
			error => {
				dispatch(updateCheckoutEmailErrorAction(error));
				return Promise.reject(error);
			}
		);
	};
}

export function applyCoinsAction(checkoutUpdateData, pincode, serviceType = SERVICE_TYPES.USE_COINS) {
	function applyCoinsRequestAction() {
		return { type: APPLY_COINS_REQUEST };
	}

	function applyCoinsSuccessAction(data) {
		return { type: APPLY_COINS_SUCCESS, data };
	}

	function applyCoinsErrorAction(error) {
		return { type: APPLY_COINS_ERROR, error };
	}

	return dispatch => {
		dispatch(applyCoinsRequestAction());
		return ApiCaller.put(
			{
				...baseAjaxConfig,
				pathname: '/api/5/checkout',
				acceptErrors: true
			},
			{
				serviceType,
				pincode,
				checkoutUpdateData: checkoutUpdateData
			}
		).then(
			json => dispatch(applyCoinsSuccessAction(json['RESPONSE'])),
			err => dispatch(applyCoinsErrorAction(err))
		);
	};
}

export function useGSTAction(businessIntent, pincode, serviceType = SERVICE_TYPES.USE_GST) {
	function useGSTRequestAction() {
		return { type: USE_GST_REQUEST };
	}

	function useGSTSuccessAction(data) {
		return { type: USE_GST_SUCCESS, data };
	}

	function useGSTErrorAction(error) {
		return { type: USE_GST_ERROR, error };
	}

	return dispatch => {
		dispatch(useGSTRequestAction());
		return ApiCaller.put(
			{
				...baseAjaxConfig,
				pathname: '/api/5/checkout',
				acceptErrors: true
			},
			{
				serviceType,
				pincode,
				businessIntent
			}
		).then(
			json => dispatch(useGSTSuccessAction(json['RESPONSE'])),
			err => dispatch(useGSTErrorAction(err))
		);
	};
}
